import React, { FC } from 'react';
import {
  Box,
  HStack,
  PlacementWithLogical,
  Text,
  Tooltip,
  VStack
} from '@chakra-ui/react';
import { BiCoinStack } from 'react-icons/bi';

interface Props {
  tooltipPlacement?: PlacementWithLogical;
}

export const VerifiedMemeBadge: FC<Props> = ({ tooltipPlacement }) => {
  return (
    <Tooltip
      label={
        <Box
          sx={{
            padding: '8px 14px',
            backgroundColor: 'gray.2',
            borderRadius: '10px',
            color: 'meme'
          }}
        >
          <ul>
            <li>&bull;&nbsp;Verified meme</li>
          </ul>
        </Box>
      }
      portalProps={{ appendToParentPortal: true }}
      placement={tooltipPlacement ?? 'top'}
      zIndex={1000}
    >
      <HStack gap={1} alignItems="center">
        <BiCoinStack size="18" color="#E59905" />
        <HStack
          gap={0}
          sx={{
            border: '1px solid',
            borderColor: 'meme',
            borderRadius: '4px',
            padding: '2px 4px',
            height: '28px'
          }}
        >
          <VStack gap={0} alignItems="center" px={2}>
            <Text
              fontSize="12px"
              color="meme"
              lineHeight={0.9}
              textAlign="center"
            >
              Verified
            </Text>
            <Text
              fontSize="12px"
              color="meme"
              lineHeight={0.9}
              // transform="translateY(-2px)"
              textAlign="center"
            >
              Meme
            </Text>
          </VStack>
        </HStack>
      </HStack>
    </Tooltip>
  );
};
